import { Flex } from "antd";
import styled from "styled-components";

export const BusinessListItemContainer = styled(Flex)(({ theme }) => ({
  flex: 1,
  gap: theme.spacing * 4,

  [`@media (max-width: ${theme.screenMDMax}px)`]: {
    flexDirection: "column",
    gap: theme.spacing * 2,
  },
}));

export const BusinessListItemPreviewContainer = styled(Flex)(({ theme }) => ({
  maxWidth: "30%",
  flexGrow: 1,

  [`@media (max-width: ${theme.screenMDMax}px)`]: {
    maxWidth: "unset",
  },
}));
